import React from "react";

export default function HeaderStats() {
  return (
    <>
      {/* Header */}
      <div className="relative bg-orange-200 md:pt-12 pb-32 pt-12">
        <div className="px-4 md:px-10 mx-auto w-full">
          <p className="text-center text-5xl text-orange-500 font-bold">AI Platform Data Monitoring</p>
        </div>
      </div>
    </>
  );
}
